<template>
  <transition name="el-zoom-in-center">
    <el-dialog title="注册" :visible.sync="add.addshow" width="45%" center @close="resetForm('form')"  :close-on-click-modal="false" >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-form-item label="分销商名字" prop="name">
          <el-input v-model="form.name" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="分销商手机" prop="phone">
          <el-input v-model="form.phone" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="form.password" style="width:50%" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="form.checkPass" autocomplete="off" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="form.companyName" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="地点"   prop="registerPosition">
          <el-row>
            <el-col :span="7">
              <el-select v-model="form.provinceName"  placeholder="选择省" @change="selectProvimce">
                <el-option
                  v-for="(item,index) of provincearr"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="7" :offset="1">
              <el-select v-model="form.cityName" placeholder="选择市" @change="selectcity">
                <el-option
                  v-for="(item,index) of cityarr"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="7" :offset="1">
              <el-select placeholder="选择区" v-model="form.areaName">
                <el-option
                  v-for="(item,index) of regionarr"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <br />
          <el-input type="textarea" v-model="form.registerPosition" placeholder="详细地址"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
         <el-button @click="resetForm('form')">重置</el-button>
        <el-button type="primary" @click="submitadd('form')">确 定</el-button>
      </span>
    </el-dialog>
  </transition>
</template>
<script>
import { registeruser } from "@/api/market/channel";
import { province } from "@/assets/js/map";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null
        };
      }
    }
  },
  created() {
    this.provincearr = province;
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      //基础数据
      // 省市区联动下拉
      arr: [1, 3, 4],
      province: [],
      cityarr: [],
      regionarr: [],
      show: true,
      form: {
        companyName: null,
        name: null,
        phone: null,
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        password: null,
        checkPass: null,
        userType: 3,
      },
      // 步骤2表格数据
      rules: {
        Remark: [
          { required: true, message: "请输入备注", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  mounted() {},
  methods: {
    // 省市区联动下拉
    selectProvimce(name) {
      this.cityarr = [];
      this.regionarr = [];
      this.form.cityName = "";
      this.form.areaName = "";
      for (let item of this.provincearr) {
        if (name == item.name) {
          console.log(item);
          this.cityarr = item.children;
        }
      }
    },
    selectcity(name) {
      this.regionarr = [];
      this.form.areaName = "";
      for (let item of this.cityarr) {
        if (name == item.name) {
          this.regionarr = item.children;
        }
      }
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          registeruser({AuthCode:"Passer",codeInfo:null,user:this.form,userType:3}).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "注册成功!"
              });
              this.search();
              this.resetForm('form');
              this.add.addshow = false;
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.cityName = "";
      this.form.areaName = "";
      this.form.provinceName = "";
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
